import React, { useContext, useState } from 'react';
import { Button, InputDescription, Modal, Toast } from '../../uiComponents/common';
import { FormProvider, useForm } from 'react-hook-form';
import Show from '../show/show';
import { useMutation, useQueryClient } from 'react-query';
import { postAddComment } from '../../services';
import { WelletContext } from '../../context/wellet/welletContext';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

const ModalAddComment = ({ reservationId }) => {
  const welletContext = useContext(WelletContext);
  const { t } = useTranslation('translation', { keyPrefix: 'modals.modalAddComment' });
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const methods = useForm({
    defaultValues: {
      comment: '',
    },
  });

  const addCommentMutation = useMutation({
    mutationFn: (data) => {
      const body = {
        comment: data?.comment,
      };
      return postAddComment(welletContext, reservationId, body);
    },
  });
  const queryClient = useQueryClient();

  const onSubmit = (data) => {
    addCommentMutation.mutate(data);
  };

  const handleClose = () => {
    methods.reset({
      comment: '',
    });
    handleModal();
  };
  const handleModal = () => {
    setOpen((prevState) => !prevState);
  };
  const handleRefetch = () => {
    queryClient.refetchQueries({ queryKey: ['reservation', id] });
    navigate(`/reservation-review/${id}/reservation`);
  };
  const handleToast = () => {
    addCommentMutation.reset();
    handleRefetch();
    handleClose();
  };

  return (
    <>
      <Button
        className={'btn-wellet-secondary bg-custom-light text-truncate btn-accept'}
        onClick={handleModal}
        size={'custom'}
        text={<>{t('button')}</>}
        disabled={!addCommentMutation.isIdle}
      />
      <Show.When isTrue={open}>
        <FormProvider {...methods}>
          <form key={'addComment'}>
            <Modal
              title={t('title')}
              open={open}
              onClose={handleClose}
              isLoading={!addCommentMutation.isIdle}
              maxWidth='600px'
              handleSubmit={methods.handleSubmit(onSubmit)}
              customButtons={
                <>
                  <div className='d-flex justify-content-end'>
                    <Button
                      text={t('cancel')}
                      disabled={!addCommentMutation.isIdle}
                      className={'btn-general btn-wellet-secondary'}
                      size={'medium'}
                      onClick={handleClose}
                    />
                    <Button
                      text={t('submit')}
                      disabled={!addCommentMutation.isIdle}
                      className={'ml-2 btn-general btn-wellet-primary'}
                      size={'medium'}
                      onClick={() => methods.handleSubmit(onSubmit)()}
                    />
                  </div>
                </>
              }
            >
              <div className='mt-2'>{t('ask')}</div>
              <div className='row mt-2'>
                <InputDescription
                  name={'comment'}
                  label={t('inputComment.label')}
                  placeholder={t('inputComment.placeholder')}
                  isRequired={true}
                  className='mb-2 col'
                  toFixed={true}
                  height='80px'
                  minLength={0}
                  maxLength={300}
                  showCharCount
                />
              </div>
            </Modal>
          </form>
        </FormProvider>
      </Show.When>

      <Show.When isTrue={addCommentMutation.isError}>
        <Toast
          message={t('toast.error')}
          type='ERROR'
          onCallback={() => addCommentMutation.reset()}
        />
      </Show.When>
      <Show.When isTrue={addCommentMutation.isSuccess}>
        <Toast message={t('toast.success')} type='SUCCESS' onCallback={handleToast} />
      </Show.When>
    </>
  );
};

export default ModalAddComment;
